import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase.ts';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!supabase) {
      setError('Supabase is not configured.');
      return;
    }

    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');

    if (code) {
      void supabase.auth.exchangeCodeForSession(code).then(({ error: exchangeError }) => {
        if (exchangeError) setError(exchangeError.message);
        else navigate('/app', { replace: true });
      });
      return;
    }

    void supabase.auth.getSession().then(({ data }) => {
      if (data.session) navigate('/app', { replace: true });
      else setError('That sign-in link did not produce a session.');
    });
  }, [navigate]);

  return (
    <main className="mx-auto max-w-prose px-6 py-16">
      <h1 className="text-3xl">Signing you in</h1>
      {error ? (
        <>
          <p className="mt-3 text-ink-muted">{error}</p>
          <p className="mt-6">
            <Link to="/login" className="text-accent-600 underline underline-offset-4">
              Try again
            </Link>
          </p>
        </>
      ) : (
        <p className="mt-3 text-ink-muted">One moment.</p>
      )}
    </main>
  );
}
